module.exports = new __parcel__URL__("presence-spotlight-img.9b9958c6.png").toString();